// Shimmer placeholder matching the shape of what's loading (design.md: no
// circular spinners). Hidden from assistive tech; the surrounding region
// carries aria-busy and a text status instead.

export function Skeleton({ width = "100%", height = 16, radius }: { width?: string | number; height?: number; radius?: string }) {
  return <span className="skeleton" aria-hidden="true" style={{ width, height, borderRadius: radius }} />;
}

export function SkeletonBlock({ lines = 3, label = "Loading" }: { lines?: number; label?: string }) {
  return (
    <div className="stack-sm" aria-busy="true" role="status">
      <span className="visually-hidden">{label}…</span>
      {Array.from({ length: lines }, (_, i) => (
        <Skeleton key={i} width={i === lines - 1 ? "60%" : "100%"} />
      ))}
    </div>
  );
}
